import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import ConsultaUsuarioResultado from "./ConsultaUsuarioResultado";

class ConsultaUsuario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        nome: "",
        email: "",
        situacao: 1
      },
      resultado: []
    };

    this.handleEmular = this.handleEmular.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleEmular(usuario) {
    UI.loader("show", "Emulando (" + usuario.nome + ")...");
    API.get("/acesso/emular/" + usuario.id)
      .then((json) => {
        this.props.onEmular(json.data);
        this.props.history.push("/inicio");
        UI.loader("hide");
      })
      .catch((json) => {
        UI.alert(json.success, json.message);
        UI.loader("hide");
      })
  }

  handleSubmit(event) {
    event.preventDefault();
    let data = this.state.consulta;

    UI.loader("show", "Um momento...");
    API.post("/usuarios/consulta", data)
      .then(
        function (json) {
          this.setState({ resultado: json.data });
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  handleChange(event) {
    let consulta = this.state.consulta;
    consulta[event.target.name] = event.target.value.toUpperCase();

    this.setState({ consulta: consulta });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">CONSULTA USUÁRIO</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/usuario/cadastro"); }}
                      className="btn btn-rounded btn-icons btn-outline-success"
                      type="button">
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <input type="hidden" name="id" value="0" />
                      <div className="col-sm-4">
                        <label>Nome</label>
                        <input
                          autoFocus
                          placeholder="NOME"
                          name="nome"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.nome}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-5">
                        <label>E-mail</label>
                        <input
                          placeholder="EMAIL"
                          name="email"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.email}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Situação</label>
                        <select
                          name="situacao"
                          className="form-control"
                          value={this.state.consulta.situacao}
                          onChange={this.handleChange}
                        >
                          <option value={0}>TODOS</option>
                          <option value={1}>ATIVO</option>
                          <option value={2}>INATIVO</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          <i className="fa fa-search"></i>&nbsp;
                            Pesquisar
                        </button>
                      </div>
                    </div>
                    <ConsultaUsuarioResultado usuario={this.props.usuario} onEmular={this.handleEmular} resultado={this.state.resultado} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(ConsultaUsuario);
